<div class="container">
  <div class="full-width">
    <div class="input-container">
      <div class="input-half" tabindex="0">
        <!-- Medicamentos -->
        <soph-medicamentos (isFormValid)="isFormMedicamentosValid = $event"></soph-medicamentos>
      </div>

      <div class="input-half" tabindex="0">
        <!-- Terapias -->
        <soph-terapias (isFormValid)="isFormTerapiasValid = $event"></soph-terapias>
      </div>
    </div>
  </div>

  <div class="full-width">
    <mat-divider></mat-divider>

    <div class="input-container">
      <div class="input-half" tabindex="0">
        <soph-procedimientos></soph-procedimientos>
      </div>

      <div class="input-half" tabindex="0">
        <soph-operaciones></soph-operaciones>
      </div>
    </div>
  </div>

  <div class="full-width">
    <mat-divider></mat-divider>

    <div class="input-container">
      <div class="input-total custom-text-area">
        <p class="texto-info">Indicaciones extra</p>
        <p>Ingresa las notas que necesites con respecto al tratamiento</p>
        <soph-textarea-with-speech-to-text-form-field
          [control]="indicacionesExtra"
          label="Indicaciones extra"
          placeholder="Indicaciones extra"
          [maxLength]="1000"
          [errorMessages]="{
            required: 'Este campo es obligatorio',
            maxlength: 'Ha excedido el número máximo de caracteres'
          }"
        >
        </soph-textarea-with-speech-to-text-form-field>
      </div>
    </div>
  </div>

  <div class="section-acction">
    <div class="button-container">
      <button
        mat-stroked-button
        class="estilo-button"
        type="button"
        (click)="openRevertChangesConfirmation()"
        [disabled]="isSavingData() || isAppointmentFinished()"
      >
        Cancelar
      </button>

      <button
        [sophHasAccess]="[AppPermissions.EDIT_TREATMENT]"
        mat-flat-button
        class="estilo-button-flat"
        type="submit"
        (click)="guardarTratamiento()"
        [disabled]="isSavingData() || isAppointmentFinished()"
      >
        @if(isSavingData()) {
        <mat-spinner diameter="24"></mat-spinner>
        } @if(!isSavingData()) {
        <span>Guardar</span>
        }
      </button>
    </div>

    <soph-finish-appointment-button />
  </div>
</div>
